function formatDate(
  rawDate: Date | string | number,
  locale?: string,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date =
    typeof rawDate === 'string' || typeof rawDate === 'number'
      ? new Date(rawDate)
      : (rawDate as Date);

  if (date && typeof date.toLocaleDateString === 'function') {
    return date.toLocaleDateString(locale, options);
  }

  return String(rawDate);
}

export default formatDate;
